module.exports = __webpack_public_path__ + "img/registration.7e850dc1.png";